import React, { useMemo }  from "react";
import {FilterCheckbox, FilterMenu, FilterSearch} from "@ofqual/portal-components/components/ResponseFilter";
import {useLookup, useSearch, useUrl} from "@ofqual/portal-core/core/hooks";
import {makeStyles, MenuItem, Theme} from "@material-ui/core";
import {FilterList} from "@material-ui/icons";
import {Select} from "@ofqual/portal-components/components/Select";
import {AdminStatusService, EvaluatorStatusService, QualificationTypeLookupsLocal, qualificationLevelsService, subjectsService} from "../../services";
import {authSelector} from "@ofqual/portal-activity-feed/activityfeed/redux/selectors";
import {useSelector} from "react-redux";
import {UserRole} from "../../redux/types";
import { ensureParamIsArray } from "@ofqual/portal-core/core/utils/urlHelper";
import { Opts, QueryParams } from "@ofqual/portal-core/core/types";
import { SearchField as ClassicSearchField } from "@ofqual/portal-components/components/SearchField";



const useStyles = makeStyles((theme: Theme) => {
    return {
        root: {
            "& fieldset": {
                borderColor: theme.palette.primary.main,
            },
        },
        menuItem: {
            "&:hover": {
                backgroundColor: "transparent",
            },
        },
    };
});

export const FilterControls: React.FC = () => {
    const classes = useStyles();
    
  const {
    searchParams,
    navigateToNextSearch,
    searchParamsFiltersOnly,
  } = useSearch(useUrl());

    const [adminStatusLookup, evaluatorStatusLookup, qualificationLevelLookup, qualificationTypeLookup] =
        useLookup(
            AdminStatusService,
            EvaluatorStatusService,
            {
                service: { getAll: (opts:Opts) => qualificationLevelsService.getAll(opts) },
                id: "id",
                label: "levelDescription",
            },
            QualificationTypeLookupsLocal
);

   
    let [statuses] = [adminStatusLookup];
    
    const currentAuth = useSelector(authSelector);
    
   
    if(currentAuth.roles.includes(UserRole.OfqualExpertsEvaluator) && currentAuth.roles.includes(UserRole.OfqualExpertsAdmin))
    {
        [statuses] = [adminStatusLookup];
    }
    else if(currentAuth.roles.includes(UserRole.OfqualExpertsEvaluator)){
        [statuses] = [evaluatorStatusLookup];
    }

  const mappedSubjectLookupService = useMemo(
    () => ({
          get: (id: string) => subjectsService.get(id.toString(), {} ),
          search: (params?: QueryParams) => {
              if (params !== undefined) {
                  var data = subjectsService.getSubjectsByTitle(params.query)
                  return data;
              }
              else {
                  var dataEmpty = subjectsService.getSubjectsByTitle("")
                  return dataEmpty;
              }
        }
    }),
    []
  );

   
    return (
        <>
            <FilterSearch
                title="Search..."
                value={searchParams.search}
                onChange={(value) =>
                    navigateToNextSearch({
                        search: value,
                    })
                }
                dataTest={"search"}
            />
            &nbsp; &nbsp;
            <FilterMenu
                Icon={FilterList}
                title="Filters"
                dataTest="filter"
                search={{ searchParamsFiltersOnly, navigateToNextSearch }}
            >
                {(workingParams, dirtyParams, addParam) => (
                    <form>
                        <MenuItem className={classes.menuItem}>
                            <Select
                                className={
                                    dirtyParams.includes("status") ? classes.root : undefined
                                }
                                label="Status"
                                data-test="status-filter"
                                value={workingParams.status}
                                onChange={(e) => addParam("status", e.target.value)}
                            >
                                {statuses}
                            </Select>
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>

                            <ClassicSearchField
                                className={
                                dirtyParams.includes("subject") ? classes.root : undefined
                                }
                                onChange={(e) => addParam("subject", e.target.value)}
                                value={ensureParamIsArray(workingParams.subject)}
                                label="Subject"
                                datatest="subject-filter"
                                service={mappedSubjectLookupService}
                                searchFieldVariant="multiple"
                            />
                        </MenuItem>

                        <MenuItem className={classes.menuItem}>
                            <Select
                            className={
                                dirtyParams.includes("qualificationTypeId") ? classes.root : undefined
                            }
                            label="Qualification type"
                            data-test="qualification-type-filter"
                            selectVariant="multiple"
                            value={ensureParamIsArray(workingParams.qualificationTypeId)}
                            onChange={(e: any) => addParam("qualificationTypeId", e.target.value)}
                            >
                            {qualificationTypeLookup.map((x) => ({
                            id: x.id.toString(),
                            label: x.label,
                            }))}
                            </Select>
                        </MenuItem>

                        
                        <MenuItem className={classes.menuItem}>
                            <Select
                            className={
                                dirtyParams.includes("qualificationLevel") ? classes.root : undefined
                            }
                            label="Qualification level"
                            data-test="qualification-level-filter"
                            selectVariant="multiple"
                            value={ensureParamIsArray(workingParams.qualificationLevel)}
                            onChange={(e: any) => addParam("qualificationLevel", e.target.value)}
                            >
                            {qualificationLevelLookup.map((x) => ({
                            id: x.id.toString(),
                            label: x.label,
                            }))}
                            </Select>
                        </MenuItem>
                        <MenuItem className={classes.menuItem}>
                        <FilterCheckbox
                            isChecked={workingParams.ukBased === "true"}
                            name="ukBased"
                            dataTest="ukbased-checkbox"
                            text="UK only"
                                onChange={() => {
                                addParam("ukBased", workingParams.ukBased === "true" ? "false" : "true")
                            }}
                        />
                        </MenuItem>


                    </form>
                )}
            </FilterMenu>
        </>
    );
};
